// extracted by mini-css-extract-plugin
export var labelWrapper = "_gh-0";